import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostBinding, Inject, OnInit} from '@angular/core';
import {filter} from 'rxjs/operators';
import {NavigationEnd, Router} from '@angular/router';
import {MenuAsideOffcanvasDirective} from '../../../core/directives/menu-aside-offcanvas.directive';
import {ClassInitService} from '../../../core/services/class-init.service';
import {LayoutConfigService} from '../../../core/services/layout-config.service';
import {LayoutRefService} from '../../../core/services/layout/layout-ref.service';
import {MenuAsideService} from '../../../core/services/layout/menu-aside.service';
import {DOCUMENT} from '@angular/common';
import * as objectPath from 'object-path';
import {LogoEmpresaService} from '../../../services/logo-empresa.service';
import {MatDialog} from '@angular/material';
import {DialogBannerMaxpagComponent} from '../../pages/components/cadastros/max-pag/banner-dialog/dialog-banner-maxpag.component';
import { MensagensService } from 'max-ng-lib';

@Component({
	selector: 'm-aside-left',
	templateUrl: './aside-left.component.html',
	styleUrls: ['./aside-left.component.scss'],
	changeDetection: ChangeDetectionStrategy.Default
})
export class AsideLeftComponent implements OnInit, AfterViewInit {

	@HostBinding('class') classes = 'm-grid__item m-aside-left';
	@HostBinding('id') id = 'm_aside_left';

	@HostBinding('attr.mMenuAsideOffcanvas') mMenuAsideOffcanvas: MenuAsideOffcanvasDirective;

	currentRouteUrl: string = '';
	insideTm: any;
	outsideTm: any;
	headerLogo: any = '';
	headerLogoCliente: any = '';
	imagemCliente;
	itensDoMenuFiltrados = [];

	constructor(
		private el: ElementRef,
		public classInitService: ClassInitService,
		public menuAsideService: MenuAsideService,
		public layoutConfigService: LayoutConfigService,
		public logoEmpresaService: LogoEmpresaService,
		private router: Router,
		private layoutRefService: LayoutRefService,
		@Inject(DOCUMENT) private document: Document,
		private dialog: MatDialog,
		private mensagemService: MensagensService
	) {
		this.menuAsideService.getMenuListAsObservable().subscribe(menus => {
			this.itensDoMenuFiltrados = this.copiarItensComSubmenus(menus);
        })

		// subscribe to menu classes update
		this.classInitService.onClassesUpdated$.subscribe(classes => {
			// join the classes array and pass to variable
			this.classes = 'm-grid__item m-aside-left ' + classes.aside_left.join(' ');
		});

		this.layoutConfigService.onLayoutConfigUpdated$.subscribe(model => {

			this.headerLogo = objectPath.get(model, 'config.header.self.logo.dark');
		});

		this.layoutConfigService.onToggleMenuAside$.subscribe(isOpened => {
            if(!isOpened) {
                this.pesquisarItensMenu('');
            }
        })
	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.mMenuAsideOffcanvas = new MenuAsideOffcanvasDirective(this.el);
			// manually call the directives' lifecycle hook method
			this.mMenuAsideOffcanvas.ngAfterViewInit();

			// keep aside left element reference
			this.layoutRefService.addElement('asideLeft', this.el.nativeElement);
		});
	}

	ngOnInit() {
		this.currentRouteUrl = this.router.url.split(/[?#]/)[0];

		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(event => this.currentRouteUrl = this.router.url.split(/[?#]/)[0]);

		this.logoEmpresaService.getLogoEmpresa()
			.subscribe(arquivo => {
				if (arquivo) {
					this.createImageFromBlob(arquivo);
				}
			});
	}

	isMenuItemIsActive(item): boolean {
		if(item.active && item.submenu) return true;

		if (item.submenu) {
			return this.isMenuRootItemIsActive(item);
		}

		if (!item.page) {
			return false;
		}

		// dashboard
		if (item.page !== '/' && this.currentRouteUrl.startsWith(item.page)) {
			return true;
		}
		return this.currentRouteUrl === item.page;
	}

	isMenuRootItemIsActive(item): boolean {
		let result = false;

		for (const subItem of item.submenu) {
			result = this.isMenuItemIsActive(subItem);
			if (result) {
				return true;
			}
		}

		return false;
	}

	openPage(item, itemElement: HTMLElement) {
		if(!this.isAsideMinimized()) return;

		if(item.msgSemAcesso) return this.openMsgSemAcesso(item);

		if(!item.submenu && !item.dialog && !item.isExternalLink) {
            return;
        }

		if(!item.submenu && item.dialog) {
            return;
        }

        if(!item.submenu && !item.dialog && item.isExternalLink) {
            window.open(item.page, '_blank', 'noopener,noreferrer');
            return;
        }
		
		if (item.submenu && this.document.body.classList.contains('m-aside-left--minimize')) {
            mUtil.removeClass(document.body, 'm-brand--minimize');
            mUtil.removeClass(document.body, 'm-aside-left--minimize');
			mUtil.removeClass(document.getElementById('m_aside_left_minimize_toggle'), 'm-brand__toggler--active');

			if (mUtil.hasClass(itemElement, 'm-menu__item--open')) {
                mUtil.addClass(itemElement, 'open-alt')
                const subMenu = itemElement.getElementsByClassName('m-menu__submenu')[0];
                mUtil.addClass(subMenu, 'open-alt')
            }

        }
        return;
    }

	createImageFromBlob(image: Blob) {
		const reader = new FileReader();
		reader.addEventListener('load', () => {
			this.imagemCliente = reader.result;
		}, false);

		if (image) {
			reader.readAsDataURL(image);
		}
	}

	openDialog(item: any) {
		if (item.dialog) {
			this.dialog.open(DialogBannerMaxpagComponent, {
				width: '650px',
				minHeight: '445px',
				data: {
					bannerLink: item.bannerLink,
					bannerImagePath: item.bannerImagePath
				}
			});
		}
	}

	isAsideMinimized() {
        return this.document.body.classList.contains('m-aside-left--minimize') && mUtil.isInResponsiveRange('desktop')
	}

	openMsgSemAcesso(item: any) {
		this.mensagemService.exibaToastAlerta(item.msgSemAcesso);
	}

	pesquisarItensMenu(termoPesquisado: string) {
		const todosOsItens = this.copiarItensComSubmenus(this.menuAsideService.getMenuList());

        if (!termoPesquisado) {
            this.itensDoMenuFiltrados = todosOsItens
            this.desativarItensMenu(this.itensDoMenuFiltrados);
            return;
        }

        const filtered = todosOsItens.filter(item => this.contemFiltro(item, termoPesquisado));
        this.itensDoMenuFiltrados = this.filtrarItensAtivos(filtered, termoPesquisado);

        return;
    }

	copiarItensComSubmenus(itensMenu) {
		const itensComSubmenus = [];
		itensMenu.forEach(item => {
			const copy = Object.assign({}, item);
			if (item.submenu) {
				copy.submenu = this.copiarItensComSubmenus(item.submenu);
			}
			itensComSubmenus.push(copy);
		});
		return itensComSubmenus;
	}

    filtrarItensAtivos(itensMenu, pesquisa) {
        const itensFiltrados = [];

        itensMenu.forEach(item => {
            if (item.active) {
                const pesquisaSemAcento: string = this.getStringSemAcentosLowerCase(pesquisa)
                const titleSemAcento: string = this.getStringSemAcentosLowerCase(item.title)
                const titleContainsFilteredData = titleSemAcento.includes(pesquisaSemAcento);

                if (!titleContainsFilteredData && item.submenu) { // Se titulo do menu não contém o que foi pesquisado, filtra os subitems que contém, se o menu principal contém, passa o menu e todos os subitems.
                    item.submenu = this.filtrarItensAtivos(item.submenu, pesquisa);
                }
                itensFiltrados.push(item);
            } else if (item.submenu) {
                const submenuFiltrado = this.filtrarItensAtivos(item.submenu, pesquisa);
                if (submenuFiltrado.length > 0) {
                    item.submenu = submenuFiltrado;
                    itensFiltrados.push(item);
                }
            }
        });
        return itensFiltrados;
    }

    getStringSemAcentosLowerCase(string) {
        return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    desativarItensMenu(itensMenu) {
        itensMenu.forEach(item => {
            item.active = false;
            if (item.submenu) {
                this.desativarItensMenu(item.submenu);
            }
        });
    }

    contemFiltro(item, pesquisa) {
        const pesquisaSemAcento: string = this.getStringSemAcentosLowerCase(pesquisa)
        const titleSemAcento: string = this.getStringSemAcentosLowerCase(item.title)

        const titleContainsFilteredData = titleSemAcento.includes(pesquisaSemAcento);

        if (!item.submenu) {
            item.active = titleContainsFilteredData;
            return titleContainsFilteredData;
        }

        let someSubmenuContainsFilteredData = false;

        item.submenu.forEach(submenu => {
            const contemFiltro = this.contemFiltro(submenu, pesquisa);
            if (contemFiltro) {
                someSubmenuContainsFilteredData = true;
                submenu.active = true;
            }
        });

        if (titleContainsFilteredData || someSubmenuContainsFilteredData) {
            item.active = true;

            return true;
        }
        item.active = false;

        return false;
    }
}
